import { createRoute } from "@tanstack/react-router";
import { appRoute } from "../../shell/routes";
import { RulesPage } from "./RulesPage";

export const rulesSettingsRoute = createRoute({ getParentRoute: () => appRoute, path: "settings/rules", component: RulesPage });
